import React from "react";
import PropTypes from "prop-types";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import { Button } from "@material-ui/core";

const RemoveBeaconDialog = ({ open, onSave, onCancel, submitting, beacon }) => {
  return (
    <Dialog open={open} fullWidth maxWidth={"sm"}>
      <DialogTitle>Usunięcie beacona</DialogTitle>
      <DialogContent>
        Czy na pewno chcesz usunać beacona o numerze{" "}
        <span style={{ fontWeight: "bold" }}>{beacon.beaconNumber}</span>?
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          Anuluj
        </Button>
        <Button onClick={() => onSave(beacon.id)} disabled={submitting}>
          Tak
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RemoveBeaconDialog.propTypes = {
  beacon: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
};

export default RemoveBeaconDialog;
